import type { PersistReducers } from "@general-backoffice/core";
import { Loading, NotificationWrapper, PersistAndProvider } from "@general-backoffice/core";
import React from "react";
import type { Store } from "redux";

import sessionState from "./redux/reducers/session/state";
import sessionStatePersistConfig from "./redux/reducers/session/statePersistConfig";
import Router from "./Router";
import refreshMe from "./utils/refreshMe";

const stores: PersistReducers = {
  sessionState: {
    persistConfig: sessionStatePersistConfig,
    baseReducer: sessionState,
  },
};

const afterRehydrate = async (reduxStore: Store) =>
  refreshMe({ state: reduxStore.getState(), dispatch: reduxStore.dispatch });

function App() {
  const loadingPage = (
    <div className="vh-100 flex-center">
      <Loading.BouncingDots size={"lg"} />
    </div>
  );

  return (
    <PersistAndProvider stores={stores} afterRehydrate={afterRehydrate} loadingScreen={loadingPage}>
      <React.Suspense fallback={loadingPage}>
        <NotificationWrapper>
          <Router />
        </NotificationWrapper>
      </React.Suspense>
    </PersistAndProvider>
  );
}

export default App;
